export default __webpack_public_path__ + "ui/assets/img/attach-file-24.svg";